import { gql } from "lib/apolloClient";
import { attachmentFragment } from "modules/CommonFragments";

export const getProjectReportTemplateDetailsQuery = gql`
  query getProjectReportTemplateDetails(
    $id: ID!
    $filters: ParentProjectGroupReportFilter
  ) {
    node(id: $id, type: PROJECT_GROUP) {
      ... on ProjectGroup {
        id
        selectedProjectReportTemplate {
          ...attachmentItem
          presetAttachment {
            ...attachmentItem
          }
        }
        allProjectReportTemplates {
          ...attachmentItem
          presetAttachment {
            ...attachmentItem
          }
          parentProjectGroupReport(filters: $filters) {
            ...attachmentItem
          }
        }
      }
    }
  }
  ${attachmentFragment.attachment}
`;
